import { useEffect, useRef } from 'react';

import type { ToothSliceGeometry } from '../config';
import {
  cancelToothBasisSeriesRoiPrefetch,
  makeToothBasisSeriesCacheKey,
  prefetchToothBasisSeriesRoi,
} from '../lib';

export const useToothBasisSeriesPrefetch = ({
  input,
  isEnabled,
  spacingOutMm,
}: {
  input: ToothSliceGeometry | null;
  isEnabled: boolean;
  spacingOutMm?: number;
}) => {
  const cacheKey =
    input && isEnabled
      ? makeToothBasisSeriesCacheKey({ input, spacingOutMm })
      : null;
  const inputRef = useRef(input);
  inputRef.current = input;

  useEffect(() => {
    const currentInput = inputRef.current;

    if (!cacheKey || !currentInput) {
      return;
    }

    prefetchToothBasisSeriesRoi({
      cacheKey,
      input: currentInput,
      spacingOutMm,
    });

    return () => cancelToothBasisSeriesRoiPrefetch(cacheKey);
  }, [cacheKey, spacingOutMm]);
};
